import { Box } from '@chakra-ui/react'

export const FormLabel = ({ children, name, ...props }) => {
  return (
    <Box fontWeight="500" htmlFor={name} fontSize="0.84rem" width="100%" mb="6px" {...props}>
      {children}
    </Box>
  )
}
